mainApp.component('comboText', {
    templateUrl: '/public/components/combo-text.component.html',
    bindings: {
        field: '<', // read only object
        presentationResolver: '<',
        selectedItems: '<', //  currently selected items to show as selected on the list
        comboId: '@',
        comboLabel : '@',
        textLabel: '@',
        updateValue: '&',
        disableValue: '@',
        textPlaceHolder: '@'
    },
    controller: function controller($scope, FieldsService, $state, IconsService) {
        var ctrl = this;
        ctrl.text = null;
        ctrl.comboValue = null;

        $scope.$on('before-adding-item', function (e) {
            if (ctrl.comboValue && !ctrl.text) {
                if (ctrl.comboValue === 'TCP/UDP') {
                    ctrl.updateValue({value: 'TCP_UDP'});
                } else {
                    ctrl.updateValue({value: ctrl.comboValue});
                }
            }
            else if (!ctrl.comboValue || !ctrl.text) {
                if (!ctrl.comboValue) {
                    ctrl.updateValue({value: '', error:'Protocol is missing'});
                } else {
                    ctrl.updateValue({value:''});
                }
            }
            else if (ctrl.comboValue === 'TCP/UDP') {
                ctrl.updateValue({value: 'TCP_UDP/' + ctrl.text});
            }
            else {
                ctrl.updateValue({value: ctrl.comboValue + '/' + ctrl.text});
            }
        });


        ctrl.setItem = function(value) {
            ctrl.errors = null;
            ctrl.comboValue = value.name;
        };

    }
});